export const demodata = {
   
    rows:[
        {
                        id: 1,
            sender: "user1",
            amount: 100,
            date: "May 03 2023 14:44:24",
        },
       
        {
                        id: 3,
            sender: "user1",
            amount: 200,
            date: "May 10 2023 14:44:24",
        },
        {
                        id: 4,
            sender: "user1",
            amount: 90,
            date: "May 11 2023 14:44:24",
        },
        {
                        id: 5,
            sender: "user1",
            amount: 70,
            date: "May 16 2023 14:44:24",
        },
      
  
    ],
    initialState:{
        columns:{
            columnVisibilityModel:{
                id: false,
                avatar: false,
                website: false,
                email: false,
                phone: false,
                username: false,
                city: false,
                company: false,
                position: false,
                lastUpdated: false,
                salary: false,
            }
        }
    }
}